<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Viga&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');

* {
    border: 0px black solid;
    background-color: #fff5f5;

}



a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.title_story {
  font-size: 80px;
  font-family: 'Work Sans', sans-serif;
  padding-left: 20px;
  padding-top: 70px;
  color: #333042
}

.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;

}

.author {
  font-size: 20px;
  font-family: 'Poppins', sans-serif;;
  padding-left: 25px;


}

.small_img {
  max-width: 60%;
  padding-bottom: 40px;
}

.small_icon {
  max-width: 20%;
  padding-top: 70px;
}


.bbq_images {
  padding-top: 40px;
  padding-bottom: 40px;
}

@media (max-width: 575px){
  .small_icon {
    max-width: 50%;
    padding-top: 20px;

  }
  .title_story {
    font-size: 30px;
  }
  .author {
    font-size: 15px;
  }
}
</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>
    <b-row>
      <b-col md="8">
        <p class="title_story">Balcony Marinade</p>
        <b-row>
          <b-col md="6">
            <p class="author">a recipe by Madyasa Vijber</p>

          </b-col>
        </b-row>
      </b-col>


      <b-col md="2" class="small_icon">
        <a href="/pesto"><b-img center class="img-fluid" alt="Responsive image" src="media/basil_prev.png"> </b-img></a>
      </b-col>
      <b-col md="2" class="small_icon">
        <a href="/cart"><b-img center class="img-fluid" alt="Responsive image" src="media/cart_next.png"> </b-img></a>
      </b-col>

    </b-row>



    <b-row class="bbq_images">
      <b-col md="2">

      </b-col>
      <b-col md="4">
        <b-img center class="small_img" src="media/bbq/bag.jpg"></b-img>


      </b-col>
      <b-col md="4">
        <b-img center class="small_img" src="media/bbq/convo.PNG"></b-img>


      </b-col>

      <b-col md="2">

      </b-col>

    </b-row>


  </b-container>

</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'bbq',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
